import { NSARouterMakerResult } from "namirasoft-account-react";
import { EmailSenderLayout } from "../EmailSenderLayout";
import { EmailSenderEntities } from "../EmailSenderEntities";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";

export interface ProviderListPageProps extends NSARouterMakerResult, EmailSenderRouterProps { }

function ProviderListPage(props: ProviderListPageProps)
{
	return (
		<EmailSenderLayout {...props}
			action={{
				description: "This section displays all Email providers you have created with their basic information.",
			}}
			pages={{
				entity: EmailSenderEntities.provider(props),
				list: {
					ui: {}
				}
			}}
		>
			<></>
		</EmailSenderLayout>
	);
}

export default ProviderListPage;